import type { TravelJournalArticlesTypeProps } from './types';
import HeroSection from './hero-section';
import Introduction from './introduction';
import ArticleGrid from './article-grid/ArticleGrid';
import CategoriesGrid from './categories-grid';

const Articles: React.FC<TravelJournalArticlesTypeProps> = ({
  articles,
  categories,
}) => {

  return (
    <main>
      <HeroSection categories={categories} />
      <Introduction />
      <ArticleGrid articles={articles.slice(0, 6)} />
      <ArticleGrid articles={articles.slice(6, 12)} />
      <CategoriesGrid categories={categories} />
      <ArticleGrid articles={articles.slice(12, 18)} />
    </main>
  );
};

export default Articles;
